import React from 'react';
import { motion } from 'framer-motion';
import { MOCKUP_URL, PRODUCT_NAME } from '../data/config';
import { heroIndicators } from '../data/kit';
import { CTAButton, Tag } from './Shared';
import { Bat, Ghost, Pumpkin, Star } from './HalloweenDecor';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header id="hero" className="relative overflow-hidden bg-brand-cream" data-id="element-114" data-mp="4n1kkpc3c8rg">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" data-id="element-115" data-mp="129qurmgy5roe">
        <Bat className="absolute left-[4%] top-10 w-12 text-brand-violet/10 md:w-16" data-id="element-116" data-mp="xanoxzt57hfd" />
        <Star className="absolute left-[46%] top-14 hidden w-5 text-brand-orange/40 lg:block" data-id="element-117" data-mp="sbb2hg66ocdb" />
        <Star className="absolute right-[6%] top-[12%] w-4 text-brand-orange/40" data-id="element-118" data-mp="sd4c94c3fcpj" />
        <Ghost className="absolute bottom-10 right-[3%] hidden w-14 text-white lg:block" data-id="element-119" data-mp="neawf59c39m7" />
        <Pumpkin className="absolute bottom-8 left-[3%] hidden w-12 text-brand-orange/25 md:block" data-id="element-120" data-mp="3d2tod9lewkej" />
      </div>

      <div className="relative mx-auto grid max-w-page gap-x-12 gap-y-3 px-5 pb-12 pt-4 sm:gap-y-8 sm:pt-10 md:px-8 md:pb-24 md:pt-16 lg:grid-cols-[1.05fr_1fr] lg:items-center" data-id="element-121" data-mp="384jtz17ihntz">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} className="text-center lg:col-start-1 lg:row-start-1 lg:self-end lg:text-left" data-id="element-122" data-mp="3o73p8bldju82">
          <p className="mb-1.5 font-display text-base font-extrabold tracking-wide text-brand-violet sm:mb-4 sm:text-xl md:text-2xl" data-id="element-123" data-mp="30hrev8eb9g46">
            Visión Digital
          </p>
          <Tag className="mb-3 !px-3 !py-1 !text-[11px] sm:mb-5 sm:!px-4 sm:!py-1.5 sm:!text-sm" data-id="element-124" data-mp="2qk3kwkoj4cn2">
            DISFRACES TENEBROSOS + OPCIONES DIVERTIDAS
          </Tag>
          <h1 className="text-balance text-[30px] font-extrabold leading-[1.08] text-brand-violet sm:text-[44px] sm:leading-[1.05] md:text-5xl lg:text-[54px]" data-id="element-125" data-mp="2vgtzt4oll26w">
            🎃 Creá su disfraz de Halloween con materiales simples,{' '}
            <span className="whitespace-nowrap underline decoration-brand-orange decoration-[4px] underline-offset-[5px] sm:decoration-[6px] sm:underline-offset-[6px]" data-id="element-126" data-mp="s1rsao8pe6ua">
              ya mismo
            </span>
          </h1>
          <p className="mx-auto mt-2.5 max-w-xl text-[15px] leading-snug text-brand-ink/85 sm:mt-5 sm:text-base sm:leading-relaxed md:text-lg lg:mx-0" data-id="element-127" data-mp="id9vei3jojvx">
            Convertí cartón, telas y materiales fáciles de conseguir en disfraces llenos de imaginación. Con ideas
            explicadas para compartir el armado en familia.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease,
        delay: 0.05
      }} className="relative mx-auto w-full max-w-[560px] lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:max-w-none" data-id="element-128" data-mp="112pud0zl04a8">
          <img src={MOCKUP_URL} alt="Kit Disfraces de Halloween: Tomo 1 Disfraces Tenebrosos, Tomo 2 Disfraces Divertidos y 5 bonus en PDF" className="mx-auto h-auto w-full max-w-[290px] drop-shadow-xl sm:max-w-[460px] lg:max-w-[580px]" fetchPriority="high" draggable={false} data-id="element-129" data-mp="3hr3s5wvh8d6c" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease,
        delay: 0.08
      }} className="text-center lg:col-start-1 lg:row-start-2 lg:self-start lg:text-left" data-id="element-130" data-mp="269r3nvyj5iak">
          <h2 className="text-lg font-extrabold leading-tight text-brand-violet sm:text-2xl md:text-[28px]" data-id="element-131" data-mp="2kydtirls9sg1">{PRODUCT_NAME}</h2>
          
          <CTAButton href="#oferta" className="mt-2.5 sm:mt-6" data-id="element-132" data-mp="2p10gae3lkn6d">
            🎃 QUIERO MI KIT
            <Bat className="w-8 shrink-0" data-id="element-133" data-mp="2tyaa05y0rl00" />
          </CTAButton>
          
          <p className="mx-auto mt-1 max-w-md text-sm text-brand-ink/70 lg:mx-0" data-id="element-134" data-mp="un9a5okh8lfo">
            Producto digital. Consultalo desde tu dispositivo o imprimí las páginas que necesites.
          </p>
          <ul className="mt-6 flex flex-wrap justify-center gap-2 lg:justify-start" data-id="element-135" data-mp="4al077oyb0k7">
            {heroIndicators.map(item => <li key={item} className="rounded-full bg-white px-3.5 py-2 text-sm font-medium text-brand-ink shadow-card" data-id="element-136" data-mp="3vgniwwf2k3sy">
                {item}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </header>;
}